
export const CashMain = () => {
    return (
        <>
            <ul>
                <li>Princess Races este o secțiune dedicată turneelor organizate de Princess Casino sau de partenerii furnizori de jocuri.
                </li>
                <li>Participă la Cursa Principală toți jucătorii cu un cont activ și validat la Princess Casino, mai puțin cei înscriși la Cursele Golden și VIP.
                </li>
                <li>Cursa Principală se desfășoară de la data de 19 Ianuarie 2022, orele 00:00, până la data de 25 Ianuarie 2022, orele 23:59 sau până când primii 100 de jucători realizează rulajul aferent.
                </li>
                <li>Închiderea/Suspendarea/Restricționarea contului din orice motive descalifică utilizatorul din promoție.
                </li>
            </ul>
            <p><strong>Participare</strong></p>
            <ul>
                <li>Sunt eligibile pentru această cursă pariuri realizate cu bani cash în perioada desfășurării competiției la toate sloturile, jocurile din categoria “Cazinou Virtual” și jocurile de Live Casino.
                </li>
                <li>Sunt excluse pariurile de tipul roșu/negru de la Ruletă. Jucătorii care vor realiza astfel de pariuri în intervalul turneului vor fi descalificați.
                </li>
                <li>Cresc în clasament jucătorii cu cel mai mare rulaj.</li>
                <li>Aduni puncte pe baza rulajului realizat. 1 RON pariat = 1 punct.</li>
            </ul>
            <p><strong>Premii</strong></p>
            <span>Primii 100 de jucători care realizează rulajul de 100.000 RON în intervalul de timp dat primesc 1.000 RON Bonus, cu 5x rulaj.</span>
            <ul>
                <li>Premiile vor fi acordate în balanța jucătorului, în următoarele 48 de ore de la încheierea competiției.
                </li>
                <li>Jucătorii vor fi anunțați pe email sau SMS după realizarea creditării premiului
                </li>
            </ul>
            <ul>
                <li>În cazuri de deconectare sau de probleme tehnice generale, toate rotirile afectate sunt anulate și excluse din promoție în scopuri de punctaj.
                </li>
                <li>Oferta respectă Termenii și Condițiile Princess Casino.
                </li>
                <li>Princess Casino își rezervă dreptul de a suspenda promoția pentru unul sau pentru toți jucătorii, fără explicații sau notificări prealabile, dacă promoția este folosită într-o manieră ce contravine Regulilor Organizatorului. În cazul unui litigiu cu un jucător, decizia Organizatorului va prevala.
                </li>
                <li>Princess Casino își rezervă dreptul de a exclude jucătorii care participă la promoții cu conturi multiple.</li>
                <li>Princess Casino își rezervă dreptul de a anula sau modifica termenii și condițiile acestei oferte fără notificare prealabilă.
                </li>
                <li>Pentru orice întrebări legate de prezenta promoție, utilizatorii sunt rugați să contacteze echipa de
                    asistență la adresa de e-mail <a
                        href="mailto:contact@princesscasino.ro">contact@princesscasino.ro</a>.
                </li>
            </ul>
        </>
    )
}